import React from "react";
import { TableCell, TableRow } from '@mui/material';
import { EyeOutlined } from "@ant-design/icons";
import Loading from "components/Loading";
import { BORDERCOLOR, convertHighlightsToBlanks, handleTypeText } from "../helper";
import { CheckCircleOutlined, Delete, Done, Edit, ScheduleOutlined, BugReport, CheckCircle } from '@mui/icons-material';
import { message } from 'antd';
import SentryWrap from 'components/Sentry';

const WorksheetTableRow = ({
  row,
  index,
  pagination,
  dataTab,
  handleEditItem,
  setDeleteToggle,
  setSelectedItem,
  handleDraftQuestion,
  approveLoading,
  setApproveToggle,
  userloading,
  onPreviewClick,
  hasEditGrammarDrill,
  hasDeleteGrammarDrill,
  hasApproveGrammarDrill
}) => {

  const checkOptionDuplicate = (question) => {
    if (!question || !question.type) return false;
    if (question.type === 'Fill_IN_THE_Blank') {
      const highlightWords = question.highlightWords?.map((item) => item?.text || '');
      const hasAny = highlightWords.every((word) =>
        question.question?.toLowerCase().includes(word?.toLowerCase()),
      );
      if (!hasAny) return true;
      if (!highlightWords?.every((word) =>  question.correct_answer?.toLowerCase().includes(word?.toLowerCase()))) return true;
      return false;
    } else {
      if (question?.options?.length > 2) {
        return true;
      }
      if (!question.options?.includes(question.correct_answer)) return true;
      const duplicate = question?.options?.filter(
        (item, index) => question?.options?.indexOf(item) !== index,
      );
      if (duplicate?.length > 0) return true;
      return false;
    }
  };

  return (
    <SentryWrap>
    <TableRow
      key={row.id}
      style={{
        "&:lastChild td, &:lastChild th": { border: 0 },
      }}
    >
      <TableCell style={{ textAlign: "left", cursor: "pointer" }}>
        {index + 1}.
      </TableCell>

      <TableCell style={{ textAlign: "left", cursor: "pointer" }}>
        {row?.type === "Fill_IN_THE_Blank" && row?.question && row?.highlightWords
          ? convertHighlightsToBlanks(row?.question, row?.highlightWords)
          : row?.question}
      </TableCell>

      <TableCell style={{ textAlign: "left", color: BORDERCOLOR[0], cursor: "pointer" }}>
        {handleTypeText(row?.type)}
      </TableCell>

      <TableCell
        style={{
          textAlign: "left",
          color: BORDERCOLOR[0],
          cursor: "pointer",
          maxWidth: 380,
        }}
      >
        {row?.type === "Fill_IN_THE_Blank"
          ? row?.highlightWords?.map((highlight) => highlight?.text).join(", ")
          : row?.correct_answer}
          {row?.correct_answer_eng?`(${row?.correct_answer_eng})`:""}
      </TableCell>

      <TableCell
        style={{
          textAlign: "left",
          color: BORDERCOLOR[0],
          cursor: "pointer",
          maxWidth: 380,
        }}
      >
        {row?.mood}
      </TableCell>

      <TableCell
        style={{
          textAlign: "left",
          color: BORDERCOLOR[0],
          cursor: "pointer",
          maxWidth: 380,
        }}
      >
        {row?.tense}
      </TableCell>

      <TableCell
        style={{
          textAlign: "left",
          color: BORDERCOLOR[0],
          cursor: "pointer",
          maxWidth: 380,
        }}
      >
        {row?.category}
      </TableCell>

      <TableCell
        style={{
          textAlign: "left",
          color: BORDERCOLOR[0],
          cursor: "pointer",
          maxWidth: 380,
        }}
      >
        {row?.pronouns}
      </TableCell>

      <TableCell
        style={{
            textAlign: "left",
            color: BORDERCOLOR[0],
            cursor: "pointer",
            maxWidth: 380,
        }}
      >
        {Number(row?.usage_count || 0)}
      </TableCell>

      <TableCell
        style={{
          textAlign: "left",
          cursor: "pointer",
          maxWidth: 380,
        }}
      >
        {checkOptionDuplicate(row) ? (
          <BugReport style={{ color: "red", verticalAlign: "middle", fontSize: 24 }} />
        ) : (
          <CheckCircle style={{ color: "green", verticalAlign: "middle", fontSize: 20 }} />
        )}
      </TableCell>

      {dataTab === "draft_question" && (
        <TableCell
          style={{
            textAlign: "left",
            color: BORDERCOLOR[0],
            cursor: "pointer",
            maxWidth: 380,
          }}
        >
          {!row?.question_audio && !row.image ? (
            <ScheduleOutlined style={{ color: "grey", verticalAlign: "middle", marginRight: "5px" }} />
          ) : row?.question_audio && row?.image ? (
            <CheckCircleOutlined style={{ color: "green", verticalAlign: "middle", marginRight: "5px" }} />
          ) : (
            <ScheduleOutlined style={{ color: "grey", verticalAlign: "middle", marginRight: "5px" }} />
          )}
        </TableCell>
      )}

      <TableCell
        style={{ textAlign: "left", color: "black", cursor: "pointer", maxWidth: 380 }}
        onClick={() => {
          if (!hasEditGrammarDrill) {
            message.warning('You do not have permission to access this feature.');
            return;
          }
          handleEditItem(row);
        }}
      >
        <Edit />
      </TableCell>

      <TableCell
        style={{ textAlign: "left", color: "red", cursor: "pointer", maxWidth: 380 }}
        onClick={() => {
          if (!hasDeleteGrammarDrill) {
            message.warning('You do not have permission to access this feature.');
            return;
          }
          setDeleteToggle(true);
          setSelectedItem(row);
        }}
      >
        <Delete />
      </TableCell>

      {dataTab !== "draft_question" && (
        <TableCell
          style={{ textAlign: "left", color: "#178fff", cursor: "pointer", marginInline: "auto" }}
          onClick={async () => {
            // This onClick is for preview eye icon
            onPreviewClick();
          }}
        >
          <EyeOutlined />
        </TableCell>
      )}

      {dataTab === "draft_question" && (
        <TableCell
          style={{ textAlign: "left", color: "red", cursor: "pointer", maxWidth: 380 }}
          onClick={() => {
            if (!hasApproveGrammarDrill) {
              message.warning('You do not have permission to access this feature.');
              return;
            }
            if (row?.image && row?.question_audio) {
              handleDraftQuestion(row);
            } else {
              setApproveToggle(true);
              setSelectedItem(row);
            }
          }}
        >
          {approveLoading === row?.id ? <Loading size={18} /> : <Done />}
        </TableCell>
      )}
    </TableRow>
    </SentryWrap>
  );
};

export default WorksheetTableRow;
